import { format, formatDistanceToNow, isValid } from 'date-fns';
// import Holidays from "date-holidays"


// ----------------------------------------------------------------------

export function fDate(date) {
  if (date == "" || date == null) {
    return ""
  } else {

    return format(new Date(date), 'dd MMMM yyyy');
  }
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy ');

}

export function fTimeOnly(date) {
  const d = new Date(date);
  if (!isValid(d)) return '';
  return format(d, 'hh:mm a');
}


export function fDateMonth(monthYear) {

  const month = monthYear.slice(0, 2);
  const year = monthYear.slice(2);
  const date = new Date(`${year}-${month}-01`);
  return date.toLocaleString('default', { month: 'long', year: 'numeric' });
};


// export function fDateTimeH(date) {
//   return format(new Date(date), 'dd MMM yyyy HH:mm:ss');
// }


export function fDateTimeH(date) {
  const parsedDate = new Date(date);
  if (!date || !isValid(parsedDate)) {
    return '--';
  }
  return format(parsedDate, 'dd MMM yyyy HH:mm:ss');
}



export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm:ss');
}

export function f_time(date) {
  return format(new Date(date), 'yyyy-MM-dd');
}



export function get_three_digit_month(date) {
  return format(new Date(date), 'yyyy-MMM-dd');
}

export function get_year_and_month_only(date) {
  return format(new Date(date), 'yyyy-MM');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}


export function fa_time(date) {
  return format(new Date(date), 'dd MMM');
}

export const getActualDateFormate = (date) => {
  const dateParts = date.split("-");
  const formattedDate = `${dateParts[0]}/${parseInt(
    dateParts[1],
    10
  )}/${parseInt(dateParts[2], 10)}`;
  return formattedDate;
};

export const today = () => {
  let abc = new Date();
  let month = abc.getMonth() + 1;
  let date = abc.getDate();
  let year = abc.getFullYear();
  let full = `${year}-${month}-${date}`;
  return full
}

export const convert_string_to_month = (expiry) => {


  const day_expiry = expiry.substring(0, 2);
  const moth_str = expiry.substring(2, 4);
  const year_expiry = expiry.substring(4);



  let month_string
  if (moth_str === "01") {
    month_string = "JAN";
  } else if (moth_str === "02") {
    month_string = "FEB";
  }
  else if (moth_str === "03") {
    month_string = "MAR";
  }
  else if (moth_str === "04") {
    month_string = "APR";
  }
  else if (moth_str === "05") {
    month_string = "MAY";
  }
  else if (moth_str === "06") {
    month_string = "JUN";
  }
  else if (moth_str === "07") {
    month_string = "JUL";
  }
  else if (moth_str === "08") {
    month_string = "AUG";
  }
  else if (moth_str === "09") {
    month_string = "SEP";
  }
  else if (moth_str === "10") {
    month_string = "OCT";
  }
  else if (moth_str === "11") {
    month_string = "NOV";
  }
  else if (moth_str === "12") {
    month_string = "DEC";
  }

  return `${day_expiry}${month_string}${year_expiry}`

}



export const isForeignUserAllowedToLogin = (userCountry, userLocalTime) => {

  const isForeignUser = userCountry !== 'IN';

  const convertedISTTime = new Date(userLocalTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));


  const hoursInIST = convertedISTTime.getHours();

  const isLoginTimeValid = hoursInIST >= 8 && hoursInIST < 23;


  return isForeignUser && isLoginTimeValid;
}


export const isToday = (date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}



export const signalfDateTime = (rawDate) => {
  if (!rawDate || rawDate.length !== 8) return '-';

  const day = rawDate.slice(0, 2);
  const month = rawDate.slice(2, 4);
  const year = rawDate.slice(4);

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const monthName = months[parseInt(month, 10) - 1];

  if (!monthName) return '-';

  return `${day} ${monthName} ${year}`;
};
